import * as types from '../common/types'
import createReducer from './createReducer'

const initialState = {
  exporting: false,
  page: { size: 10, number: 1 },
}

export const logs = createReducer(initialState, {
  [types.SET_LOGS_COUNT](state, { count }) {
    return {
      ...state,
      count,
    }
  },
  [types.SET_LOGS_PAGE_NUMBER](state, { page }) {
    return {
      ...state,
      page: {
        ...state.page,
        number: page,
      },
    }
  },
  [types.SET_LOGS_PAGE_SIZE](state, { size }) {
    return {
      ...state,
      page: {
        ...state.page,
        size,
      },
    }
  },
  [types.TOGGLE_LOGS_EXPORTING](state) {
    return {
      ...state,
      exporting: !state.exporting,
    }
  },
})
